import React from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import moment from "moment";

const TABLE_SCROLL_Y = 360;

const SupplierTransactionList = ({ list, scrollY = TABLE_SCROLL_Y }) => {
	const columns = [
		{
			title: "ID",
			dataIndex: "id",
			key: "id",
			render: (id) => <Link to={`/transaction/${id}`}>{id}</Link>,
		},
		{
			title: "Date",
			dataIndex: "date",
			key: "date",
			render: (date) => moment(date).format("DD/MM/YYYY"),
		},
		{
			title: "Debit",
			dataIndex: "debit",
			key: "debit",
			render: (debit) => debit?.name,
		},
		{
			title: "Credit",
			dataIndex: "credit",
			key: "credit",
			render: (credit) => credit?.name,
		},
		{ title: "Amount", dataIndex: "amount", key: "amount" },
		{ title: "Type ", dataIndex: "type", key: "type" },
		{ title: "Particulars", dataIndex: "particulars", key: "particulars" },
	];

	const addKeys = (arr) => arr.map((i) => ({ ...i, key: i.id }));

	const table = (
		<Table
			scroll={{ x: true, y: scrollY }}
			loading={!list}
			columns={columns}
			dataSource={list ? addKeys(list) : []}
			size="small"
		/>
	);

	return (
		<div className="sup-detail-section">
			<h5 className="sup-detail-section-heading">All Transaction Information</h5>
			<div className="detail-page-table-wrap">
				{table}
			</div>
		</div>
	);
};

export default SupplierTransactionList;
